(function () {
  var PREFIX = '#scroll-';

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href^="' + PREFIX + '"]');
    if (!link) return;

    var key = link.getAttribute('href').slice(PREFIX.length);
    var target = document.querySelector('[id$="__' + key + '"]');
    if (!target) return;

    event.preventDefault();

    var openDrawer = link.closest('x-drawer[open]');
    if (openDrawer) {
      openDrawer.addEventListener(
        'dialog:after-hide',
        function () {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        },
        { once: true }
      );
      openDrawer.hide();
    } else {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
})();
